import productLoop from "@/assets/product-loop.mp4.asset.json";

export function ProductVideo({ src, poster }: { src?: string; poster?: string }) {
  return (
    <video
      src={src ?? productLoop.url}
      poster={poster}
      autoPlay
      loop
      muted
      playsInline
      preload="metadata"
      className="w-full aspect-video bg-black object-cover"
    />
  );
}
